var version = {
    "name":      "dativery",
    "buildDateCode": "20261020-122844",
    "buildDate": "Tue Oct 20 2026 12:28:44 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261020-122844",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;